import { type Localization } from './Interface'

export const localizationNl: Localization = {
  country: {
    BE: { text: 'België' },
    BG: { text: 'Bulgarije' },
    CZ: { text: 'Tsjechië' },
    DK: { text: 'Denemarken' },
    DE: { text: 'Duitsland' },
    EE: { text: 'Estland' },
    IE: { text: 'Ierland' },
    EL: { text: 'Griekenland' },
    ES: { text: 'Spanje' },
    FR: { text: 'Frankrijk' },
    HR: { text: 'Kroatië' },
    IT: { text: 'Italië' },
    CY: { text: 'Cyprus' },
    LV: { text: 'Letland' },
    LT: { text: 'Litouwen' },
    LU: { text: 'Luxemburg' },
    HU: { text: 'Hongarije' },
    MT: { text: 'Malta' },
    NL: { text: 'Nederland' },
    AT: { text: 'Oostenrijk' },
    PL: { text: 'Polen' },
    PT: { text: 'Portugal' },
    RO: { text: 'Roemenië' },
    SI: { text: 'Slovenië' },
    SK: { text: 'Slowakije' },
    FI: { text: 'Finland' },
    SE: { text: 'Zweden' },
    IS: { text: 'IJsland' },
    LI: { text: 'Liechtenstein' },
    NO: { text: 'Noorwegen' },
    CH: { text: 'Zwitserland' },
    UK: { text: 'Verenigd Koninkrijk' },
    US: { text: 'Verenigde Staten' },
  },
  'top-menu': {
    logout: { text: 'Logout' },
    'certificate-list': { text: 'Certificaten' },
    'company-list': { text: 'Ondernemingen' },
    'certificate-instance-list': { text: 'Certificatie instellingen' },
    'user-list': { text: 'Gebruikers' },
    'certificate-type-list': { text: 'Certificaat types' },
    'logging-list': { text: 'Logging' },
    login: { text: 'Login' },
  },
  certificate: {
    'add-company': { text: 'Voeg certificaat toe' },
    'filter-company-postcode-label': { text: 'Postcode' },
    'filter-company-postcode-helper': {
      text: 'Geef (een deel van) de postcode van een gelinkte onderneming in',
    },
    'filter-company-input-label': { text: 'Onderneming' },
    'filter-company-input-helper': {
      text: 'Geef (een deel van) de naam van de onderneming in',
    },
    'filter-certificate-type-input-label': { text: 'Certificaat type' },
    'filter-certificate-type-input-helper': {
      text: 'Kies een certificaat type',
    },
    'filter-status-input-label': { text: 'Status' },
    'filter-status-input-helper': {
      text: 'Kies een status',
    },
    'filter-scope-input-label': { text: 'Scope' },
    'filter-scope-input-helper': { text: 'Geef (een deel van) de scope in' },
    certificateNumber: { text: 'Certificaat nummer' },
    companyBranches: { text: 'Onderneming(en)' },
    certificateInstanceVatNumber: { text: 'Certificaat instantie' },
    certificateInstanceName: { text: 'Certificaat instantie' },
    companyNames: { text: 'Onderneming(en)' },
    calculatedStatus: { text: 'Status' },
    companyPostcodes: { text: 'Onderneming postcodes' },
    status: { text: 'Status' },
    type: { text: 'Type' },
    edit: { text: 'Editeer certificaat' },
    delete: { text: 'Verwijder certificaat' },
    naceCodes: { text: 'NACE codes' },
    scope: { text: 'Scope' },
    certificateInstances: { text: 'Certificatie instantie' },
    issueDate: { text: 'Uitgereikt op' },
    validFrom: { text: 'Geldig van' },
    validUntil: { text: 'Geldig tot' },
    'scope-max-length-helper': {
      text: '{remainingLength}/{maxLength} tekens resterend',
      parameters: ['remainingLength', 'maxLength'],
    },
    isGroupCertificate: { text: 'Is multi-vestiging' },
    addCompanyBranch: { text: 'Selecteer onderneming of typ BTW nummer' },
    'add-companyBranch': { text: 'Selecteer bestaande onderneming' },
    'create-new-company': { text: 'Of maak nieuwe onderneming' },
    extendedUntil: { text: 'Verlengd tot' },
    'safe-add-button': { text: 'Voeg certificaat toe' },
    'type-missing': { text: 'Selecteer een geldig type' },
    'certificateNumber-missing': {
      text: 'Geef een geldige certificaat nummer in',
    },
    'naceCodes-missing': { text: 'Geef minstens één geldige NACE code in' },
    'scope-missing': { text: 'Geef een geldige scope in' },
    'companyBranches-missing': {
      text: 'Kies minstens één onderneming en vestiging',
    },
    'certificateInstanceVatNumber-missing': {
      text: 'Kies een certificaat instantie',
    },
    'extendedUntil-missing': { text: 'Geef een geldige datum in' },
    'filter-company-postcodes-input-label': {
      text: 'Postcodes',
    },
    'filter-company-postcodes-input-helper': {
      text: 'Geef komma gescheiden postcodes voor ondernemingen in',
    },
    'any-certificate-type': { text: 'Alle certificaat types' },
    'any-certificate-instance': { text: 'Alle certificaat instanties' },
    'filter-certificate-instance-input-label': {
      text: 'Certificatie instantie',
    },
    'filter-certificate-instance-input-helper': {
      text: 'Kies een certificaat instantie',
    },
    'filter-certificate-number-input-label': {
      text: 'Certificaat nummer',
    },
    'filter-certificate-number-input-helper': {
      text: 'Geef (een deel van) het certificaat nummer in',
    },
    'confirm-certificate-delete': {
      text: 'Bent u zeker dat u dit certificaat wilt verwijderen?',
    },
  },
  'logging-list': {
    'filter-email-input-label': { text: 'Email' },
    'filter-email-input-helper': {
      text: 'Geef (een deel van) het email address van de gebruiker in',
    },
    'filter-action-input-label': { text: 'Action' },
    'filter-action-input-helper': { text: 'Geef (een deel van) actie in' },
    changeDate: { text: 'Datum' },
    userEmail: { text: 'Email' },
    action: { text: 'Actie' },
    details: { text: 'Details' },
  },
  'certificate-add': {
    type: { text: 'Type' },
    certificateNumber: { text: 'Certificaat nummer' },
    naceCodes: { text: 'NACE codes' },
    scope: { text: 'Scope' },
    'scope-max-length-helper': {
      text: '{remainingLength}/{maxLength} tekens resterend',
      parameters: ['remainingLength', 'maxLength'],
    },
    isGroupCertificate: { text: 'Is multi-vestiging' },
    companyBranches: { text: 'Ondernemingen en vestigingen' },
    addCompanyBranch: { text: 'Selecteer onderneming of typ BTW nummer' },
    'add-companyBranch': { text: 'Selecteer bestaande onderneming' },
    'create-new-company': { text: 'Of maak nieuwe onderneming' },
    status: { text: 'Status' },
    Valid: { text: 'Valid' },
    Prolonged: { text: 'Prolonged' },
    Suspended: { text: 'Suspended' },
    Withdrawn: { text: 'Withdrawn' },
    certificateInstances: { text: 'Certificatie instantie' },
    issueDate: { text: 'Uitgereikt op' },
    validFrom: { text: 'Geldig van' },
    validUntil: { text: 'Geldig tot' },
    extendedUntil: { text: 'Verlengd tot' },
    'safe-edit-button': { text: 'Opslagen' },
    'certificate-save-in-progress': {
      text: 'Het certificaat word momenteel opgeslagen.',
    },
    'companyBranches-not-selected': {
      text: 'Kies minstens één vestiging',
    },
  },
  components: {
    'select-from-list': { text: 'Selecteer uit de lijst' },
    'select-no-options-match-search': {
      text: 'Geen enkele optie komt overeen met de zoekterm',
    },
    'data-being-loaded': { text: 'De data word momenteel geladen.' },
    loading: { text: '...' },
  },
  company: {
    'add-company': { text: 'Voeg onderneming toe' },
    'vat-number': { text: 'Ondernemingsnummer' },
    'invalid-vat-number': {
      text: 'Geef een geldig vat nummer startende met de landcode',
    },
    name: { text: 'Naam' },
    'legal-form': { text: 'Rechtsvorm' },
    email: { text: 'Email' },
    website: { text: 'Website' },
    addressLine1: { text: 'Straat en huisnummer' },
    postalCode: { text: 'Postcode' },
    city: { text: 'Gemeente' },
    country: { text: 'Land' },
    naceCode: { text: 'NACE Code' },
    'accident-counts': { text: 'Arbeidsongevallen cijfers' },
    branches: { text: 'Vestigingen' },
    'safe-add-button': { text: 'Voeg onderneming toe' },
    'filter-vat-number-input-label': { text: 'Ondernemingsnummer' },
    'filter-vat-number-input-helper': {
      text: 'Geef (een deel van) de het ondernemingsnummer in',
    },
    'filter-company-input-label': { text: 'Onderneming' },
    'filter-company-input-helper': {
      text: 'Geef (een deel van) de naam van de onderneming in',
    },
    vatNumber: { text: 'Ondernemingsnummer' },
    legalForm: { text: 'Rechtsvorm' },
    edit: { text: 'Editeer onderneming' },
    delete: { text: 'Verwijder onderneming' },
    'nace-code': { text: 'NACE Code' },
    certificates: { text: 'Certificaten' },
    'reload-vat-info': { text: 'Herlaad onderneming informatie' },
    'add-accident-count': { text: 'Voeg jaar toe' },
    'safe-edit-button': { text: 'Opslagen' },
    'vat-info-fetch-in-progress': {
      text: 'Gegevens voor onderneming {vatNumber} worden opgehaald',
      parameters: ['vatNumber'],
    },
    'remove-accident-count': { text: 'Verwijder jaar' },
    'company-save-in-progress': {
      text: 'De onderneming word momenteel opgeslagen.',
    },
    lastKpbCheck: { text: 'Laatste syncronisatie KBO' },
    'change-company-vat': { text: 'Wijzig onderneming ondernemingsnummer' },
    'old-vat-number': {
      text: 'Verander ondernemingsnummer {vatNumber}',
      parameters: ['vatNumber'],
    },
    'change-vat': { text: 'Wijzig ondernemingsnummer' },
    'confirm-company-delete': {
      text: 'Bent u zeker dat u deze onderneming wilt verwijderen?',
    },
    'kbo-success': { text: 'Success' },
    'kbo-failure': { text: 'Mislukt' },
  },
  'certificate-instance': {
    'add-certificate-instance': { text: 'Voeg certificaat instantie toe' },
    'filter-name-input-label': { text: 'Naam' },
    'filter-name-input-helper': {
      text: 'Geef (een deel van) de naam van de certificaat instantie in',
    },
    name: { text: 'Naam' },
    addressLine1: { text: 'Straat en huisnummer' },
    postalCode: { text: 'Postcode' },
    city: { text: 'Gemeente' },
    countryCode: { text: 'Land' },
    'vat-number': { text: 'Ondernemingsnummer' },
    'invalid-vat-number': {
      text: 'Geef een geldig vat nummer startende met de landcode',
    },
    email: { text: 'Email' },
    website: { text: 'Website' },
    telephone: { text: 'Telefoon' },
    country: { text: 'Land' },
    coordinators: { text: 'VCA coordinators' },
    'safe-add-button': { text: 'Voeg certificaat instantie toe' },
    edit: { text: 'Editeer certificaat instantie' },
    delete: { text: 'Verwijder certificaat instantie' },
    'coordinator-name': { text: 'Naam' },
    'coordinator-email': { text: 'Email' },
    'coordinator-telephone': { text: 'GSM' },
    certificates: { text: 'Certificaten' },
    'reload-vat-info': { text: 'Herlaad onderneming informatie' },
    'remove-coordinator': { text: 'Verwijder coordinator' },
    'add-coordinator': { text: 'Voeg VCA coordinator toe' },
    'safe-edit-button': { text: 'Opslagen' },
    'name-missing': { text: 'Geef een geldige naam in' },
    'email-missing': { text: 'Geef een geldig email address in' },
    'vat-info-fetch-in-progress': {
      text: 'Gegevens voor onderneming {vatNumber} worden opgehaald',
      parameters: ['vatNumber'],
    },
    'email-invalid': { text: 'Email formaat is incorrect' },
    'website-invalid': { text: 'Website formaat is incorrect' },
    'telephone-required': { text: 'GSM is verplicht' },
    'telephone-invalid': { text: 'Telefoon formaat is incorrect' },
    'certificate-instance-save-in-progress': {
      text: 'De certificaat instantie word momenteel opgeslagen.',
    },
    'confirm-certificate-instance-delete': {
      text: 'Bent u zeker dat u deze certificaat instantie wilt verwijderen?',
    },
  },
  'user-list': {
    'add-user': { text: 'Voeg gebruiker toe' },
    'filter-email-input-label': { text: 'Email' },
    'filter-email-input-helper': {
      text: 'Geef (een deel van) het email address van de gebruiker in',
    },
    email: { text: 'Email' },
    isAdmin: { text: 'Is administrator' },
    certificateInstanceVatNumber: { text: 'Certificaat instantie' },
  },
  user: {
    email: { text: 'Email' },
    'is-admin': { text: 'Is administrator' },
    'certificate-instance': { text: 'Certificaat instantie' },
    'remove-button': { text: 'Verwijder gebruiker' },
    'safe-add-button': { text: 'Voeg gebruiker toe' },
    'email-invalid': { text: 'Email formaat is incorrect' },
    'user-save-in-progress': {
      text: 'De gebruiker word momenteel opgeslagen.',
    },
    'delete-user-prompt': {
      text: 'Ben je zeker dat je deze gebruiker permanent wilt verwijderen?',
    },
    'user-delete-in-progress': {
      text: 'De gebruiker word momenteel verwijderd.',
    },
  },
  'certificate-type': {
    'add-certificate-type': { text: 'Voeg certificaat type toe' },
    'filter-name-input-label': { text: 'Naam' },
    'filter-name-input-helper': {
      text: 'Geef (een deel van) de naam van het certificaat type in',
    },
    'filter-is-active-input-label': { text: 'Is actief' },
    'filter-is-active-input-helper': { text: 'Is het actief of niet' },
    yes: { text: 'is actief' },
    no: { text: 'is niet actief' },
    'filter-nace-limitation-input-label': { text: 'NACE beperking' },
    'filter-nace-limitation-input-helper': {
      text: 'Geef (een deel van) de NACE beperking in',
    },
    name: { text: 'Naam' },
    isActive: { text: 'Is actief' },
    naceLimitation: { text: 'Beperkt tot NACE codes' },
    'safe-add-button': { text: 'Voeg certificaat toe' },
    'name-missing': { text: 'Geef een geldige certificaat type naam in' },
  },
  'certificate-type-add': {
    name: { text: 'Naam' },
    isActive: { text: 'Is actief' },
    naceLimitation: { text: 'Beperkt tot NACE codes' },
    'safe-edit-button': { text: 'Opslagen' },
    'certificate-type-save-in-progress': {
      text: 'Het certificaat type word momenteel opgeslagen.',
    },
  },
  login: {
    'login-email': { text: 'Login email' },
    'login-button': { text: 'Inloggen' },
    'login-email-send': {
      text: 'Indien de email gelinkt is aan een account. Hebben we een login link verstuurd naar het opgegeven email address. klik op deze link om in te loggen.',
    },
  },
  'certificate-statuses': {
    'any-status': { text: 'Alle statussen' },
    Expired: { text: 'Verlopen' },
    Valid: { text: 'Geldig' },
    Prolonged: { text: 'Verlengd' },
    Suspended: { text: 'Opgeschort' },
    Withdrawn: { text: 'Ingetrokken' },
  },
  general: {
    cancel: { text: 'Annuleer' },
    save: { text: 'Opslaan' },
  },
}
